import {
  Button,
  Flex,
  Tag,
  TagCloseButton,
  TagLabel,
  TagLeftIcon,
} from '@chakra-ui/react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { ComponentGridRenderer } from '~/core/routes/dev/ComponentGridRenderer';
import { PageTemplate } from '~/core/routes/dev/PageTemplate';
import { Icon } from '~/packages/common-frontend/components/icons';
import { COLOR_SCHEMES, SIZES } from '~/packages/common-frontend/theme';

// Constants
const COMPONENT_NAME = './chakra/Tag';
const VARIANTS = ['solid-muted', 'outline-muted', 'ghost'] as const;

// Exports
export const Route = () => (
  <RouteErrorBoundary
    resetAfterCatch={false}
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <div>Uh oh</div>;
    }}
  >
    <PageTemplate title={COMPONENT_NAME}>
      <ComponentGridRenderer
        primaries={VARIANTS}
        primaryPropName="variant"
        secondaries={COLOR_SCHEMES}
        secondaryPropName="colorScheme"
        tertiaries={SIZES}
        tertiaryPropName="size"
        width="15rem"
      >
        {({ primary: variant, secondary: colorScheme, tertiary: size }) => {
          return (
            <Flex
              direction="column"
              gap="0.5rem"
              alignItems="flex-start"
              flexGrow={1}
            >
              <Tag variant={variant} colorScheme={colorScheme} size={size}>
                <TagLeftIcon>
                  <Icon icon="message-lines" />
                </TagLeftIcon>
                <TagLabel>With Icon</TagLabel>
              </Tag>
              <Tag variant={variant} colorScheme={colorScheme} size={size}>
                <TagLabel>Close Button</TagLabel>
                <TagCloseButton />
              </Tag>
              <Button
                as={Tag}
                variant={(() => {
                  if (variant === 'solid-muted') return 'primary-muted';
                  if (variant === 'outline-muted') return 'secondary-muted';
                  if (variant === 'ghost') return 'v2-ghost';
                  return undefined;
                })()}
                colorScheme={colorScheme}
                size={size}
                borderRadius="10rem"
              >
                <TagLeftIcon>
                  <Icon icon="message-lines" />
                </TagLeftIcon>
                <TagLabel>Button As Tag</TagLabel>
              </Button>
              <Tag
                as={RouterLink}
                to="#"
                variant={variant}
                colorScheme={colorScheme}
                size={size}
              >
                <TagLeftIcon>
                  <Icon icon="message-lines" />
                </TagLeftIcon>
                <TagLabel>Tag As Link</TagLabel>
              </Tag>
            </Flex>
          );
        }}
      </ComponentGridRenderer>
    </PageTemplate>
  </RouteErrorBoundary>
);
